
export default {
  getCritters () {
    const c = [
      { name: 'Beaver', id: 1 },
      { name: 'Bobwhite', id: 2 },
      { name: 'Eagle', id: 3 },
      { name: 'Fox', id: 4 },
      { name: 'Owl', id: 5 },
      { name: 'Bear', id: 6 },
      { name: 'Buffalo', id: 7 },
      { name: 'Antelope', id: 8 }
    ]
    return c
  },
  getCritterNameList () {
    const cr = ['', 'Beaver', 'Bobwhite', 'Eagle', 'Fox', 'Owl', 'Bear', 'Buffalo', 'Antelope']
    return cr
  },
  getCrittersFullList () {
    const c = [
      { name: 'Beaver', id: 1 },
      { name: 'Bobwhite', id: 2 },
      { name: 'Eagle', id: 3 },
      { name: 'Fox', id: 4 },
      { name: 'Owl', id: 5 },
      { name: 'Bear', id: 6 },
      { name: 'Buffalo', id: 7 },
      { name: 'Antelope', id: 8 },
      { name: 'Crow', id: 9 },
      { name: 'Wolf', id: 10 },
      { name: 'Other', id: 11 }
    ]
    return c
  }
}
